import * as statsAnalytics from './stats.analytics';
import * as statsEvents from './stats.events';

/**
 * This API help to save and obtain session and life user activity stats
 */
export namespace Stats {
  export const api = {
    ...statsAnalytics,
    ...statsEvents,
  };
}

export type StatsModule = typeof Stats;
